import api from './client';
import { CreateIntegratorRequest, Integrator, Invitation } from '../types';

export const integratorApi = {
  list: () => api.get<Integrator[]>('/api/admin/integrators'),
  create: (data: CreateIntegratorRequest) => api.post<Integrator>('/api/admin/integrators', data),
  update: (id: string, data: CreateIntegratorRequest) =>
    api.put<Integrator>(`/api/admin/integrators/${id}`, data),
  invite: (id: string, email: string, firstName?: string, lastName?: string) =>
    api.post<Invitation>(`/api/admin/integrators/${id}/invite`, { email, firstName, lastName }),
  invitations: (id: string) => api.get<Invitation[]>(`/api/admin/integrators/${id}/invitations`),
  allInvitations: () => api.get<Invitation[]>('/api/admin/integrators/invitations'),
  resendInvitation: (invitationId: string) =>
    api.post<Invitation>(`/api/admin/integrators/invitations/${invitationId}/resend`),
  cancelInvitation: (invitationId: string) =>
    api.delete(`/api/admin/integrators/invitations/${invitationId}`),
  uploadLogo: (id: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    // Jawny multipart — klient axios ma domyślny Content-Type: application/json,
    // który bez nadpisania trafia też do FormData (backend odpowiada wtedy 415).
    return api.post<Integrator>(`/api/admin/integrators/${id}/logo`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteLogo: (id: string) => api.delete<Integrator>(`/api/admin/integrators/${id}/logo`),

  // Self-service: firma zalogowanego staffu (podgląd — cały staff, logo — admin integratora).
  me: () => api.get<Integrator>('/api/integrators/me'),
  uploadMyLogo: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.post<Integrator>('/api/integrators/me/logo', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteMyLogo: () => api.delete<Integrator>('/api/integrators/me/logo'),
};
